export default __webpack_public_path__ + "static/agentReviewPicture-d5242388e5a3790bf4754d5a1b857fe6.svg";